import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";
import { useCustomTheme } from "../../../contexts/CustomThemeContext";

type Props = {
  label: string;
  value: string;
  helper?: string;
};

const FinanceStatCard: React.FC<Props> = ({ label, value, helper }) => {
  const { theme } = useCustomTheme();

  return (
    <Box
      bg={theme.surface}
      border={`1px solid ${theme.border}`}
      borderRadius="20px"
      boxShadow={theme.shadowSm}
      p={5}
    >
      <Text
        fontSize="xs"
        textTransform="uppercase"
        letterSpacing="0.08em"
        color={theme.textMuted}
        fontWeight="700"
        mb={2}
      >
        {label}
      </Text>
      <Heading size="md" color={theme.text} mb={helper ? 2 : 0}>
        {value}
      </Heading>
      {helper ? (
        <Text fontSize="sm" color={theme.textSubtle}>
          {helper}
        </Text>
      ) : null}
    </Box>
  );
};

export default FinanceStatCard;
